var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcTabMySelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 17C1 14.2386 3.23858 12 6 12H14C16.7614 12 19 14.2386 19 17C19 17.5523 18.5523 18 18 18H2C1.44772 18 1 17.5523 1 17Z",
    fill: "#6E42FF",
    stroke: "#6E42FF",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 5,
    r: 4,
    fill: "#6E42FF",
    stroke: "#6E42FF",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTabMySelected);
export default __webpack_public_path__ + "static/media/ic_tab_my_selected.433348d4b4341631a33689dbc2b20dbe.svg";
export { ForwardRef as ReactComponent };